import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from '@angular/router';
import * as $ from 'jquery';
import {
  transition,
  trigger,
  query,
  style,
  animate,
  group,
  animateChild
} from '@angular/animations';
//import { SocketProvider } from "./services/socket.service";


//declare var google: any;
@Component({
  selector: "digilocaly-app",
  templateUrl: './app.component.html',
  styleUrls: ["./app.component.scss"],
  animations: [
    trigger('animRoutes', [
      transition('* <=> *', [
        group([
          query(
            ':enter',
            [
              style({
                opacity: 0,
                transform: 'translateY(9rem) rotate(-10deg)'
              }),
              animate(
                '0.35s cubic-bezier(0, 1.8, 1, 1.8)',
                style({ opacity: 1, transform: 'translateY(0) rotate(0)' })
              ),
              animateChild()
            ],
            { optional: true }
          ),
          query(
            ':leave',
            [animate('0.35s', style({ opacity: 0 })), animateChild()],
            { optional: true }
          )
        ])
      ])
    ])
  ]
})

export class AppComponent implements OnInit {
  constructor(private router: Router) {
    //_socketService.init();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }

  public ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

  getPage(outlet) {
    console.log(outlet);
    return outlet.activatedRouteData['page'] || 'Home';
  }

  public acceptClick() {

    var sawCookiesNotice = sessionStorage.getItem("sawCookiesNotice");
    debugger

    //if (sawCookiesNotice != "yes") {
      var element = document.getElementById("cookies-notice");
      element.classList.add("go-down");


      // $("#cookies-notice").removeClass("go-down");
      // }

    //   $("#cookies-accept").click(function () {
    //     $("#cookies-notice").addClass("go-down");
    //     sessionStorage.setItem("sawCookiesNotice", "yes");
    //   });
    // }
  }
}




// var sawCookiesNotice = sessionStorage.getItem("sawCookiesNotice");
// 	if (sawCookiesNotice != "yes") {
// 		$("#cookies-notice").removeClass("go-down");
// 	}

// 	$("#cookies-accept").click(function(){
// 		$("#cookies-notice").addClass("go-down");
// 		sessionStorage.setItem("sawCookiesNotice", "yes");
// 	})


// WEBPACK FOOTER //
// ./src/app/app.component.ts